import makeStyles from '@mui/styles/makeStyles'

const PAYWALL_HEIGHT = 604
const TRANSPARENT_HEIGHT = 100
const WRAPPER_MARGIN_TOP = -112
const WRAPPER_MARGIN_BOTTOM = 224

export const useStyles = makeStyles(({ spacing, palette, typography, breakpoints }) => ({
  wrapper: {
    position: 'relative',
    marginTop: `${WRAPPER_MARGIN_TOP}px`,
    bottom: 0,
    left: 0,
    right: 0,
    height: `${PAYWALL_HEIGHT}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    [breakpoints.down('lg')]: {
      marginBottom: `${WRAPPER_MARGIN_BOTTOM}px`
    },
    [breakpoints.down('sm')]: {
      paddingLeft: spacing(2),
      paddingRight: spacing(2)
    },
    zIndex: 2,
    [breakpoints.up('lg')]: {
      minHeight: '375px',
      marginTop: 'initial'
    }
  },
  transparentContainer: {
    height: `${TRANSPARENT_HEIGHT}px`,
    width: '100%',
    backgroundColor: '#FFF',
    opacity: 0,
    [breakpoints.up('lg')]: {
      height: '0px'
    }
  },
  messageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#283745',
    width: '100%',
    minHeight: '454px',
    position: 'relative',
    marginTop: '24px',
    [breakpoints.down('lg')]: {
      width: '660px'
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      position: 'fixed',
      bottom: 0
    }
  },
  messageContainerExclusive: {
    minHeight: '375px'
  },
  messageBorder: {
    background: '#283745',
    '&:before': {
      content: "''",
      borderLeft: '10px solid #E29D3C',
      borderRight: '10px solid #E29D3C',
      marginLeft: '-4px',
      marginRight: '-5px',
      position: 'absolute',
      color: palette.grey[90],
      top: '205px',
      height: '190px',
      [breakpoints.down('sm')]: {
        left: 'calc(50vw - 260px)',
        right: 'calc(50vw - 260px)'
      },
      left: '70px',
      right: '70px',
      [breakpoints.down('sm')]: {
        textAlign: 'center',
        height: '220px',
        top: '230px',
        left: 'calc(50vw - 200px)',
        right: 'calc(50vw - 200px)'
      },
      [breakpoints.down(450)]: {
        left: 'calc(50vw - 164px)',
        right: 'calc(50vw - 165px)'
      },
      boxSizing: 'border-box',
      transform: 'translateY(-50%)'
    }
  },
  messageBorderExclusive: {
    '&:before': {
      top: '200px',
      height: '100px',
      [breakpoints.down('sm')]: {
        height: '100px'
      }
    }
  },
  titleContainer: {
    position: 'absolute',
    left: '70px',
    right: '70px',
    top: '24px',
    [breakpoints.down('sm')]: {
      left: 'calc(50vw - 200px)',
      right: 'calc(50vw - 200px)'
    },
    [breakpoints.down(450)]: {
      left: 'calc(50vw - 164px)',
      right: 'calc(50vw - 165px)'
    },
    maxWidth: 511
  },
  title: {
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#FFF',
    textAlign: 'left',
    [breakpoints.down('sm')]: {
      fontSize: '18px',
      lineHeight: '24px'
    }
  },
  subtitle: {
    color: '#FFF',
    fontSize: '16px',
    textAlign: 'left'
  },
  message: {
    fontSize: '16px',
    position: 'absolute',
    top: '95px',
    padding: '16px',
    height: '220px',
    lineHeight: '24px',
    transform: 'translate(-50%)',
    width: '510px',
    background: 'white',
    [breakpoints.down('sm')]: {
      top: '105px',
      textAlign: 'left',
      fontSize: '14px',
      padding: '8px',
      width: '390px',
      height: '250px',
      lineHeight: '16px'
    },
    [breakpoints.down(450)]: {
      fontSize: '14px',
      padding: '8px',
      width: '320px',
      lineHeight: '16px'
    }
  },
  meteringMessageHeading: {
    [breakpoints.down('sm')]: {
      textAlign: 'left',
      fontSize: '14px',
      padding: '8px',
      lineHeight: '20px'
    }
  },
  messageExclusive: {
    height: '132px',
    top: '136px',
    [breakpoints.down('sm')]: {
      textAlign: 'left',
      fontSize: '14px',
      padding: '8px',
      width: '390px',
      height: '132px',
      lineHeight: '16px'
    },
    [breakpoints.down(450)]: {
      textAlign: 'center',
      fontSize: '14px',
      padding: '8px',
      width: '320px',
      height: '132px',
      lineHeight: '16px'
    }
  },
  meteringMessage: {
    fontSize: '16px',
    marginLeft: spacing(1),
    marginTop: spacing(1),
    marginBottom: spacing(1)
  },
  actionButtonContainer: {
    position: 'absolute',
    bottom: '50px',
    [breakpoints.down('sm')]: {
      bottom: '16px'
    }
  },
  actionButtonContainerExclusive: {
    bottom: '24px'
  },
  actionButton: {
    marginTop: spacing(2),
    color: 'white',
    background: '#EF7D00',
    minWidth: '375px',
    [breakpoints.down('sm')]: {
      minWidth: '285px',
      width: '285px'
    }
  },
  ctaSubTitle: {
    color: '#FFF',
    marginTop: '8px',
    textAlign: 'center'
  },
  bold: {
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '24px'
  },
  messageItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  ctaLink: {
    '&:visited': {
      color: 'white'
    }
  }
}))
